import styled from 'styled-components';

import { basicSmallTextStyle } from '@dreryk/react-components';

export const StyledVisitDate = styled.div`
   ${basicSmallTextStyle}
`;

StyledVisitDate.displayName = 'StyledVisitDate';
